/** CLT (Crédito do Trabalhador) e CLT Leilão × Celcoin. */

import { httpV1 as http } from '@/services/api';

const ALT_API_URL = `${process.env.VUE_APP_ALT_BASE_API_URL || process.env.VUE_APP_BASE_API_URL}/v1`;

export async function consult(params) {
  return http.get('/private-payroll/celcoin/balance', { params });
}

export async function simulate(data) {
  return http.post('/private-payroll/celcoin/simulation', data);
}

export async function creditOperation(data) {
  return http.post(`${ALT_API_URL}/private-payroll/celcoin/ccb-issuance`, data);
}

export async function proposal(params) {
  return http.get('/private-payroll/celcoin/proposal', { params });
}

export async function cancelReservation(data) {
  return http.post(`${ALT_API_URL}/private-payroll/celcoin/cancel`, data);
}

export async function relaunch(data) {
  return http.post(`${ALT_API_URL}/private-payroll/celcoin/relaunch`, data);
}

export async function riskAnalysis(data) {
  return http.post(`${ALT_API_URL}/private-payroll/celcoin/risk-analysis`, data);
}

export async function employeeRelationship(params) {
  return http.get('/private-payroll/celcoin/employment-relationships-inquiry', { params });
}

/* FGTS */

/* Quitação (PayoffCharges) */
export async function listOpenInstallments(params) {
  return http.get('/celcoin/private-payroll/payoff/installments', { params });
}

export async function generateBankSlip(data) {
  return http.post('/celcoin/private-payroll/payoff/generate-bank-slip', data);
}

export async function cancelBankSlip(params) {
  return http.delete('/celcoin/private-payroll/payoff/bank-slip', { params });
}

export async function listBankSlips(params) {
  return http.get('/celcoin/private-payroll/payoff/bank-slips', { params });
}
